export default "__VITE_ASSET__BbcqgMRE__"